<template>
	<div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-5 zoom">
		<div class="_plan b-white shadow-lg">
			<div class="_header b-gray-light py-5 text-center align-items-center">
				<h3 class="font-weight-bold m-0">GRATIS</h3>
				<br>
			</div>
			<div class="_content ">
				<div class="_ font-blue px-3 py-2 mt-3"><h6>Tu membresía actual incluye:</h6></div>
				<ul class="list-unstyled mt-3 font-blue" style="background: #edf9ff;">
					<li class="px-3 py-2"  style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Llena tu perfil</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Accede a sección de candidatos</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Ve tu perfil básico</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Conoce tu reputación</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Búsqueda por palabras clave</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Subir vacantes sin acceso a filtros de
						<span>restricción</span></li>
				</ul>
				<ul class="list-unstyled mt-3 text-left font-gray-dark px-3 py-2">

					<li  style="list-style-type: none;">
						<i class="fas fa-check text-white"></i>
						Filtros avanzados <span>*</span>
					</li>
					<li  style="list-style-type: none;">
						<i class="fas fa-check text-white"></i>
						Contacta hasta candidatos
					</li>
					<li style="margin-left: 20px; list-style-type: none;">
						<small>No acumulables</small>
					</li>
					<li style="list-style-type: none;">
						<i class="fas fa-check text-white"></i>
						Comparte flyer virtual <span>**</span>
					</li>
					<ul class="__social list-inline" style="margin-left: 20px">
						<li class="list-inline-item font-size-15" style="list-style-type: none;">
							<i class="fab fa-whatsapp"></i>
						</li>
						<li class="list-inline-item font-size-15" style="list-style-type: none;">
							<i class="fab fa-facebook-f"></i>
						</li>
						<li class="list-inline-item font-size-15" style="list-style-type: none;">
							<i class="fas fa-envelope"></i>
						</li>
						<li class="list-inline-item font-size-15" style="list-style-type: none;">
							<i class="fab fa-twitter"></i>
						</li>
					</ul>
				</ul>
				<ul class="list-unstyled mt-3 text-left font-gray-dark px-3 py-2">
					<li style="list-style-type: none;">
						<b><i class="fas fa-check text-white"></i> Accede a perfil completo</b>
					</li>
					<li style="margin-left: 20px; list-style-type: none;">
						<small>
							Competencias y Habilidades
						</small>
					</li>
					<li style="list-style-type: none;">
						<b><i class="fas fa-check text-white"></i> Kllaar Match</b>
					</li>
					<li style="margin-left: 20px; list-style-type: none;">
						<small>
							Te mostraremos a los candidatos con mayor compatibilidad en <b>Tiempo Real</b>
							<br><br><br>
						</small>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<style scoped>
.zoom {
	transition: transform .5s ease;
}

.zoom:hover {
	z-index: 2;
	transform: scale(1.1);
}

.b-gray-light {
	background-color: #dadada !important;
	color: #fff !important;
}

._plan {
	border-radius: 30px 30px 30px 30px;
	min-height: 652px;
}

._plan ._header {
	border-radius: 30px 30px 0 0;
}

._plan .custom-select {
	font-size: 20px;
	border: 0;
	border-bottom: 1px solid #EEE;
}
</style>
<script>
export default {
	data() {
		return {}
	},
	methods: {},
}
</script>



// WEBPACK FOOTER //
// src/components/#public/member/components/PlanGratis.vue